<template>
    <form
        @submit.prevent="submit"
        :action="url"
        method="post"
        class="card space-y-4"
    >
        <h2 v-if="creating" class="heading-2">Create Your Profile</h2>
        <h2 v-else class="heading-2">Update Your Profile</h2>

        <text-input
            label="Business Name"
            placeholder="Happy Little Trees Face Painting"
            v-model="form.business_name"
            :error="form.errors.business_name"
        />

        <text-area-input
            label="Description"
            placeholder="Please describe your face painting business."
            v-model="form.description"
            :error="form.errors.description"
            rows="5"
        />

        <select-input
            label="Country"
            v-model="form.country"
            :error="form.errors.country"
        >
            <option value="">Please choose one</option>
            <option v-for="country in countries" :key="country.id" :value="country.abbreviation">{{ country.name }}</option>
        </select-input>

        <div
            v-if="form.country"
            class="flex space-x-4"
        >
            <text-input
                label="City"
                placeholder="City"
                class="flex-1"
                v-model="form.city"
                :error="form.errors.city"
            />
            <text-input
                v-if="selectedCountry.has_regions"
                :label="selectedCountry.regions_name"
                :placeholder="selectedCountry.regions_name"
                class="ml-auto w-1/5"
                v-model="form.region"
                :error="form.errors.region"
            />
        </div>

        <select-input
            v-if="form.country"
            label="Rate"
            v-model="form.rate"
            :error="form.errors.rate"
        >
            <option value="">Please choose one</option>
            <option v-for="option in rateOptions" :key="option" :value="option">{{ selectedCountry.currency }}{{ option }} / hour</option>
        </select-input>

        <select-input
            v-if="form.country"
            label="Travel Distance"
            v-model="form.travel_distance"
            :error="form.errors.travel_distance"
        >
            <option value="">Please choose one</option>
            <option v-for="option in travelDistanceOptions" :key="option" :value="option">{{ option }} {{ selectedCountry.distance_unit }}</option>
        </select-input>

        <url-input
            label="Website"
            v-model="form.website"
            :error="form.errors.website"
        />

        <text-input
            label="Email"
            placeholder="bob.ross@facepainters.com"
            v-model="form.email"
            :error="form.errors.email"
        />

        <text-input
            label="Phone Number"
            placeholder="555-867-5309"
            v-model="form.phone_number"
            :error="form.errors.phone_number"
        />

        <loading-button
            :loading="form.processing"
            class="ml-auto btn btn-green"
        >
            {{ creating ? 'Create' : 'Update' }}
        </loading-button>
    </form>
</template>

<script setup>
import useForm from '@/functions/useForm'
import { range, isEmpty } from 'lodash'
import { computed, watch } from 'vue'


const props = defineProps({
    url: {
        type: String,
        required: true,
    },
    profile: {
        type: Object,
        default: () => ({})
    },
    countries: {
        type: Array,
        required: true
    }
})

const form = useForm({
    business_name: props.profile?.business_name ?? '',
    description: props.profile?.description ?? '',
    country: props.profile?.country ?? '',
    city: props.profile?.city ?? '',
    region: props.profile?.region ?? '',
    rate: props.profile?.rate ?? '',
    travel_distance: props.profile?.travel_distance ?? '',
    website: props.profile?.website ?? 'http://',
    email: props.profile?.email ?? '',
    phone_number: props.profile?.phone_number ?? '',
})

const selectedCountry = computed(() => {
    return props.countries.find(country => form.country == country.abbreviation) ?? {}
})

const rateOptions = computed(() => {
    return range(
        selectedCountry.value.currency_step,
        selectedCountry.value.currency_max,
        selectedCountry.value.currency_step,
    )
})

const travelDistanceOptions = computed(() => {
    return range(
        selectedCountry.value.distance_unit_step,
        selectedCountry.value.distance_unit_max,
        selectedCountry.value.distance_unit_step,
    )
})

const creating = computed(() => {
    return isEmpty(props.profile)
})

watch(() => form.country, () => {
    form.region = ''
    form.city = ''
    form.rate = ''
    form.travel_distance = ''
})

const submit = () => {
    form.put(props.url, {
        onSuccess: () => window.location.reload()
    })
}
</script>
